import { MapItemWithCoodId } from "@/types/search";
import React from "react";
import { GenericProjectsList } from "./generic-projects-list";

interface NonMatchingProjectsListProps {
	projectData: MapItemWithCoodId[];
	columnsCount: number;
}

export const NonMatchingProjectsList = React.memo(function NonMatchingProjectsList({
	projectData,
	columnsCount,
}: NonMatchingProjectsListProps) {
	const headerContent = React.useCallback(({ count }: { count: number }) => {
		if (count > 0) {
			const propertyText = count === 1 ? "property" : "properties";
			return {
				text: `${count} ${propertyText} around this location`,
				icon: (
					<svg className="w-5 h-5 text-amber-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
						<path
							strokeLinecap="round"
							strokeLinejoin="round"
							strokeWidth={2}
							d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
						/>
						<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
					</svg>
				),
			};
		}
		return null;
	}, []);

	return <GenericProjectsList projectData={projectData} columnsCount={columnsCount} headerContent={headerContent} />;
});
